import React from 'react'
import AppContainer from '../Components/Structure/AppContainer';
import { Link } from 'react-router-dom';

const ErrorPage = props => {
 
    return (
        <AppContainer title={"Error Page"} >

            
            <div className="row">
                <div className="col-12 col-xl-12">
                    <div className="box user-pro-list overflow-hidden mb-30" style={{marginBottom: "30px", backgroundColor: "white", padding: "25px" ,boxShadow: "10px", borderRadius: "10px"}}>
                        <div className="box-body" style={{position:"relative"}}>
                            <div className="user-pic text-center" >
                                
                                <div className="pro-user mt-3" style={{marginTop: "1rem"}}>
                                    <h1 className="text-danger mb-3" style={{fontSize: "2rem"}}>404 - Page Not Found</h1>
                                    <h3 className="pro-user-username text-dark mb-2 fs-15 mt-42 color-span" style={{lineHeight: "1.5"}}>
                                        Oops! You have landed on a page that doesn't exist.
                                    </h3>
                                    <h6 className="pro-user-desc text-muted fs-14 mb-3">
                                        The page you're looking for might have been removed or is temporarily unavailable.<br/>
                                        Please check the URL or use the button below to return to the dashboard.
                                    </h6>
    
                                </div>
                            </div>
                        </div>

                        <div className="box-footer pt-41" style={{paddingTop: "41px !important"}}>
                            <div className="btn-list text-center">
                                <Link to={'/'} className="btn ripple btn-info btn-md mr-2"><i className="fa fa-arrow-left mr-1"></i>Dashboard</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </AppContainer>
    )
}

export default ErrorPage;